import React from "react";

export default function GellerLogo() {
  return (
    <a href="/" className="geller-logo-link">
      <img
        className="new-hero-logo"
        src={require("../../assets/new_geller_white.svg")}
        alt="Geller Logo"
      />
    </a>
  );
}


// WEBPACK FOOTER //
// src/components/GellerLogo/GellerLogo.jsx